import { render, staticRenderFns } from "./Scarabs.vue?vue&type=template&id=4009e3b7&"
import script from "./Scarabs.vue?vue&type=script&lang=js&"
export * from "./Scarabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports